const megaMenuContentArabic = {
  mainNav: [
    {
      text: "الرئيسية",
    },
    {
      text: "الشركة",
    },
    {
      text: "ماذا نفعل",
    },
    {
      text: "معرض الأعمال",
    },
    {
      text: "استأجر خبراء",
    },
    {
      text: "دعونا نتواصل",
    },
    {
      text: "دراسات الحالة",
    },
  ],
  company: {
    heading: "رؤى وخدمات الشركة",
    items: [
      {
        text: "الصناعات",
        subText:
          "اكتشف حلولًا تقنية مخصصة تعالج تحديات الصناعة الفريدة وتدفع الابتكار.",
        link: "/Industries",
      },
      {
        text: "الحياة في بيتسكلان",
        subText:
          "استكشف ثقافتنا النابضة بالحياة، حيث يغذي الابتكار والعمل الجماعي كل نجاح.",
        link: "/life-at-bitsclan",
      },
      {
        text: "دراسات الحالة",
        subText: "اكتشف قصص النجاح الواقعية والحلول التكنولوجية المبتكرة التي قدمناها.",
        link: "/case-studies",
      },
      {
        text: "المدونات",
        subText:
          "اغوص في الرؤى والقصص والتحديثات التي تشكل رحلتنا في التكنولوجيا والابتكار.",
        link: "/blogs",
      },
      {
        text: "نماذج التعاقد",
        subText:
          "نموذج التعاقد يبسط التعاون من خلال تحديد النطاق والأدوار والمخرجات.",
        link: "/engagment-model",
      },
    ],
  },
  whatWeDo: {
    heading: "حلول تقنية مبتكرة",
    items: [
      // {
      //   text: "تطوير الذكاء الاصطناعي",
      //   subText:
      //     "أطلق العنان للحلول الذكية التي تعمل على أتمتة عمليات الأعمال وتحسينها والارتقاء بها.",
      //   link: "/artificial-intelligence-development-services",
      // },
      {
        text: "الأمن السيبراني",
        subText:
          "حماية أصولك الرقمية من خلال حلول أمنية شاملة ضد التهديدات المتطورة.",
        link: "/cyber-security-services",
      },
      {
        text: "تطوير البلوك تشين",
        subText: "بناء حلول لا مركزية آمنة وشفافة لإحداث ثورة في الصناعات.",
        link: "/blockchain-development-services",
      },
      {
        text: "تحليلات البيانات",
        subText:
          "تحويل البيانات إلى رؤى قابلة للتنفيذ لدفع عملية اتخاذ القرار المستنير والنمو.",
        link: "/data-analytics-services",
      },
      {
        text: "تطوير تطبيقات الويب",
        subText:
          "صياغة تطبيقات ويب قوية وقابلة للتطوير للارتقاء بأعمالك عبر الإنترنت.",
        link: "/web-app-development-services",
      },
      {
        text: "التطوير المخصص",
        subText: "حلول برمجية مصممة خصيصًا لتلبية احتياجات عملك الفريدة.",
        link: "/custom-software-development-services",
      },
      {
        text: "تطوير تطبيقات الهاتف المحمول",
        subText: "إنشاء تجارب محمولة بديهية تجذب المستخدمين وتدفع نمو الأعمال.",
        link: "/mobile-app-development-services",
      },
      {
        text: "خدمات ديف أوبس",
        subText: "تبسيط التطوير والعمليات لتقديم أسرع وتعاون معزز.",
        link: "/dev-ops-services",
      },
      {
        text: "خدمات ضمان الجودة",
        subText:
          "ضمان أعلى مستويات الجودة من خلال الاختبارات الصارمة والتحقق من الأداء الخالي من العيوب.",
        link: "/quality-assurance-services",
      },
    ],
  },
  hireExperts: {
    heading: "وظّف خبرائنا",
    items: [
      {
        text: "وظّف مطوري روبي أون ريلز",
        subText:
          "مطورون خبراء في روبي أون ريلز جاهزون لبناء تطبيقات ويب قابلة للتطوير وفعالة لعملك.",
        link: "/hire-ruby-on-rails-developer",
      },
      {
        text: "وظّف مطوري جانغو",
        subText:
          "مطورون ماهرون في جانغو لإنشاء تطبيقات ويب قوية وعالية الأداء مصممة خصيصًا لاحتياجاتك.",
        link: "/hire-django-developer",
      },
      {
        text: "وظّف مطوري بايثون",
        subText:
          "مطورون موهوبون في بايثون متاحون لتقديم حلول متعددة الاستخدامات وفعالة لمشاريعك.",
        link: "/hire-python-developers",
      },
      {
        text: "وظّف مطوري جولانج",
        subText:
          "مطورون متميزون في جولانج جاهزون لبناء تطبيقات عالية الأداء بكفاءة وسرعة.",
        link: "/hire-golang-developer",
      },
      {
        text: "وظّف مطوري جافا سكريبت",
        subText:
          "مطورون ذوو خبرة في جافا سكريبت لإنشاء تطبيقات ويب ديناميكية وتفاعلية مصممة خصيصًا لرؤيتك.",
        link: "/hire-javascript-developer",
      },
      {
        text: "وظّف مطوري رياكت",
        subText:
          "مطورون ماهرون في رياكت متاحون لتصميم واجهات مستخدم سريعة الاستجابة وعالية الأداء لتطبيقاتك.",
        link: "/hire-react-js-developers",
      },
      {
        text: "وظّف مطوري رفرفة",
        subText:
          "مطورون خبراء في رفرفة جاهزون لبناء تطبيقات جميلة مجمعة أصلاً للجوال والويب وسطح المكتب من قاعدة تعليمات برمجية واحدة.",
        link: "/hire-flutter-developers",
      },
      {
        text: "وظّف مطوري أندرويد",
        subText:
          "مطورون ذوو خبرة في أندرويد لإنشاء تطبيقات جوال بديهية وقوية مصممة لمستخدمي أندرويد.",
        link: "/hire-android-developers",
      },
      {
        text: "وظّف مطوري الزاوي",
        subText:
          "مطورون متميزون في الزاوي مكرسون لبناء تطبيقات ويب ديناميكية وعالية الأداء مع تجربة مستخدم سلسة.",
        link: "/hire-angular-developer",
      },
      {
        text: "وظّف مطوري ميرن ستاك",
        subText:
          "مطورون ماهرون في ميرن ستاك جاهزون لبناء تطبيقات متكاملة مع مونغو دي بي و إكسبريس.جي إس و ريأكت و نود.جي إس لتحقيق الأداء الأمثل.",
        link: "/hire-mern-stack-developer",
      },
      {
        text: "وظّف مطوري نود.جي إس",
        subText:
          "مطورون ذوو خبرة في نود.جي إس لإنشاء تطبيقات من جانب الخادم قابلة للتطوير وفعالة تدعم عملك.",
        link: "/hire-node-js-developer",
      },
    ],
  },
};

export default megaMenuContentArabic;
